<template>
  <svg width="24" height="25" viewBox="0 0 24 25" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M4 4.5C3.44772 4.5 3 4.94772 3 5.5V6.5C3 7.05228 3.44772 7.5 4 7.5H20C20.5523 7.5 21 7.05228 21 6.5V5.5C21 4.94772 20.5523 4.5 20 4.5H4ZM4 9.5C4 8.94772 4.44772 8.5 5 8.5H19C19.5523 8.5 20 8.94772 20 9.5V20.5C20 21.0523 19.5523 21.5 19 21.5H5C4.44772 21.5 4 21.0523 4 20.5V9.5ZM9 12.5C9 11.9477 9.44772 11.5 10 11.5H14C14.5523 11.5 15 11.9477 15 12.5C15 13.0523 14.5523 13.5 14 13.5H10C9.44772 13.5 9 13.0523 9 12.5Z"
      fill="currentColor"
    />
  </svg>
</template>
